@use '../../../../../../../styles/Constants.scss' as Constants;
@use '../../../../../../../styles/Colors.scss' as Colors;


.work-locations {
	position: relative;
	display: flex;
	flex-flow: column;
	padding-bottom: Constants.$val-spacing-l;

	&__work-location {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-m;
		justify-content: flex-start;
		margin-bottom: Constants.$val-spacing-m;

		&--removed {
			color: Colors.$col-canceledRed;
		}

		&--header {
			font-weight: normal;
			margin-top: 0;
		}
	}

	&__map-container {
		padding-left: 0;
		padding-right: 0;
	}


	&__added-address-info, &__added-address-content {
		margin-bottom: Constants.$val-spacing-xs;
		padding: Constants.$val-spacing-xs;
	}

	&__added-address-info {
		display: inline-block;
	}
}

